import produce from 'immer';
import {
	FETCH_POSTBOXES_PENDING,
	FETCH_POSTBOXES_FULFILLED,
	FETCH_POSTBOXES_FAILED,
} from '../constants/actions/postboxesActions';
import IPostboxesReducer from '../interfaces/reducers/postboxesReducer';

const initialValues: IPostboxesReducer = {
	postboxes: null,
	postboxesLoading: false,
	postboxesError: false,
};

const postboxesReducer = produce((draft: IPostboxesReducer, action) => {
	switch (action.type) {
		case FETCH_POSTBOXES_PENDING: {
			draft.postboxesLoading = true;
			draft.postboxesError = false;
			break;
		}
		case FETCH_POSTBOXES_FULFILLED: {
			draft.postboxesLoading = false;
			draft.postboxes = action.payload.postOffices;
			draft.postboxesError = false;
			break;
		}
		case FETCH_POSTBOXES_FAILED: {
			draft.postboxesLoading = false;
			draft.postboxesError = true;
			break;
		}
		default: {
			break;
		}
	}
}, initialValues);

export default postboxesReducer;
